export default "__VITE_ASSET__D12Sx4hr__"